import { useLocation, useParams } from "react-router-dom";
import { useEffect, useRef } from "react";
import { Line } from "react-chartjs-2";
import { setAdAnalytics } from "src/store/features/adsSlice";
import { setSingleAdAnalytics } from "src/store/features/adsSlice";
//@ts-ignore
import html2pdf from "html2pdf.js";
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
} from "chart.js";
import styled from "styled-components";
import { DashboardLayout } from "src/components/dashboard";
import {
	useAppDispatch,
	useAppSelector,
	setSelectedAd,
	setLoadingSingle,
	setAdsError,
	useLazyGetSingleAdQuery,
	useLazyGetSingleAdinfoQuery,
} from "src/store";
import type { Advertisement } from "src/store/features/adsSlice";
import reachIcon from "../../assets/images/ads/reachIcon.png";
import clicksIcon from "../../assets/images/ads/clicksIcon.png";
import impresionIcon from "../../assets/images/ads/impressionIcon.png";
import { useState } from "react";
import { AdAnalytics } from "src/store/features/adsSlice";

// Register ChartJS components
ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend
);

const InsightsContainer = styled.div`
	padding: 16px;

	.header-card {
		background: linear-gradient(135deg, #7c2ebd 0%, #6a1cb1 60%, #5a17a0 100%);
		color: white;
		border-radius: 12px;
		padding: 18px 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 16px;
	}

	.export-btn {
		background: white;
		color: #6a1cb1;
		border: none;
		padding: 10px 16px;
		border-radius: 8px;
		font-weight: 600;
		cursor: pointer;
	}

	.stats-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 16px;
		margin: 16px 0 20px;
	}

	.stat-card {
		background: #ede7f6;
		border: 1px solid #e6e2f1;
		border-radius: 10px;
		padding: 14px;
	}
	.stat-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 8px;
	}
	.stat-icon {
		width: 20px;
		height: 20px;
	}
	.stat-title {
		font-size: 12px;
		color: #5f5a6b;
		margin-bottom: 6px;
	}
	.stat-value {
		font-size: 22px;
		font-weight: 700;
		color: #3a3541;
	}

	.panel {
		background: #ffffff;
		border: 1px solid #ebe9f3;
		border-radius: 12px;
	}
	.panel-body {
		padding: 18px;
	}

	.split-grid {
		display: grid;
		grid-template-columns: 1.2fr 0.8fr;
		gap: 16px;
		margin-top: 18px;
	}

	.table {
		width: 100%;
		border-collapse: collapse;
		background: white;
		border: 1px solid #ebe9f3;
		border-radius: 12px;
		overflow: hidden;
	}
	.table tr {
		border-bottom: 1px solid #f0eef6;
	}
	.table td {
		padding: 12px 14px;
		font-size: 14px;
	}
	.table td:first-child {
		width: 38%;
		color: #6b6675;
	}

	.media-card {
		background: #fff;
		border: 1px solid #ebe9f3;
		border-radius: 12px;
		padding: 14px;
	}
	.media-card img {
		width: 100%;
		border-radius: 10px;
		object-fit: cover;
	}

	.status-badge {
		display: inline-flex;
		padding: 4px 12px;
		border-radius: 16px;
		font-size: 14px;
		font-weight: 500;
	}
	.status-badge.completed {
		background: #e6f4ea;
		color: #1e8e3e;
	}
	.status-badge.pending {
		background: #fef7e6;
		color: #f29d38;
	}
	.status-badge.premium {
		background: #e8f0fe;
		color: #1a73e8;
	}
`;

// Using Advertisement type from the store
type AdData = Advertisement;

interface ChartDataset {
	label: string;
	data: number[];
	borderColor: string;
	tension: number;
}

interface ChartData {
	labels: string[];
	datasets: ChartDataset[];
}

const AdInsights = () => {
	const { adId, adminId  } = useParams();
	const id = adId
	console.log({id})
	console.log({adId})
	console.log({adminId})
	// const { id } = useParams();
	const location = useLocation();
	const dispatch = useAppDispatch();
	const dispatchInfo = useAppDispatch();
	const contentRef = useRef<HTMLDivElement>(null);
	

	const { selectedAd, loadingSingle } = useAppSelector((state) => state.ads);
	const [getSingleAd] = useLazyGetSingleAdQuery();
	const [getSingleAdInfo] = useLazyGetSingleAdinfoQuery();
	const { analytics } = useAppSelector(state => state.ads);
	const { analyticsInfo } = useAppSelector(state => state.ads);

	

	useEffect(() => {
		const fetchInsightsInfo = async () => {
			console.log(id)
			if (!id) return;

			dispatchInfo(setLoadingSingle(true));
			dispatchInfo(setAdsError(null));

			try {
				const resultinfo = await getSingleAdInfo(id).unwrap();

				// dispatch(setSelectedAd(result.payload.ad));
				dispatch(setSingleAdAnalytics( resultinfo.payload));

				
			} catch (error: any) {
				const errorMessage =
					error?.data?.error?.message || "Error fetching insights";
				dispatch(setAdsError(errorMessage));
				console.error("Error fetching insights:", error);
			} finally {
				dispatch(setLoadingSingle(false));
			}
		};

		fetchInsightsInfo();
	}, [id, dispatchInfo, getSingleAdInfo]);

	useEffect(() => {
		const fetchInsights = async () => {
			if (!id) return;

			dispatch(setLoadingSingle(true));
			dispatch(setAdsError(null));

			try {
				const result = await getSingleAd(id).unwrap();

				// dispatch(setSelectedAd(result.payload.ad));
				dispatch(setAdAnalytics(result.payload));
			} catch (error: any) {
				const errorMessage =
					error?.data?.error?.message || "Error fetching insights";
				dispatch(setAdsError(errorMessage));
				console.error("Error fetching insights:", error);
			} finally {
				dispatch(setLoadingSingle(false));
			}
		};

		fetchInsights();
	}, [id, dispatch, getSingleAd]);

	const getDatesArray = (start: string, end: string): string[] => {
		const dates: string[] = [];
		const current = new Date(start);
		const endDate = new Date(end);

		while (current <= endDate) {
			dates.push(new Date(current).toLocaleDateString());
			current.setDate(current.getDate() + 1);
		}
		return dates;
	};
console.log(analyticsInfo)

const chartData: ChartData | null = analytics
  ? {
      labels: analytics.dataPoints.map((point) =>
        new Date(point.period).toLocaleDateString()
      ),
      datasets: [
        {
          label: "Views",
          data: analytics.dataPoints.map((point) => point.views),
          borderColor: "#7607BD",
          tension: 0.4,
        },
        {
          label: "Clicks",
          data: analytics.dataPoints.map((point) => point.clicks),
          borderColor: "#FFAD4A",
          tension: 0.4,
        },
      ],
    }
  : null;

	const chartOptions = {
		responsive: true,
		plugins: {
			legend: {
				position: "top" as const,
			},
			title: {
				display: true,
				text: "Ad Performance Metrics",
			},
		},
		scales: {
			y: {
				beginAtZero: true,
				title: {
					display: true,
					text: "Number of Users",
				},
			},
			x: {
				title: {
					display: true,
					text: "Date",
				},
			},
		},
	};

	const handleExportPDF = () => {
		if (!contentRef.current) return;

		const element = contentRef.current;
		const opt = {
			margin: 1,
			filename: `ad-insights-${selectedAd?.title || "report"}.pdf`,
			image: { type: "jpeg", quality: 0.98 },
			html2canvas: {
				scale: 2,
				useCORS: true,
				logging: true,
			},
			jsPDF: {
				unit: "in",
				format: "a4",
				orientation: "portrait",
			},
		};

		html2pdf().set(opt).from(element).save();
	};

	if (loadingSingle) {
		return <div>Loading...</div>;
	}

	if (!analyticsInfo) {
		return <div>No data available</div>;
	}

	const formatDate = (
		dateString: string,
		includeTime: boolean = false
	): string => {
		const options: Intl.DateTimeFormatOptions = {
			year: "numeric",
			month: "long",
			day: "numeric",
			...(includeTime && {
				hour: "2-digit",
				minute: "2-digit",
			}),
		};
		return new Date(dateString).toLocaleDateString("en-US", options);
	};

	// console.log(analyticsInfo.ad.title)
	// // console.log(analyticsInfo.ad.title)
	// console.log(analyticsInfo.ad)

	return (
		<DashboardLayout>
			
						<InsightsContainer>
							<div className='header-card'>
								<h1>Ad Insights - {analyticsInfo.ad.title}</h1>
								<button className='export-btn' onClick={handleExportPDF}>
									Export PDF
								</button>
							</div>
			
							 <div ref={contentRef}>
								<div className='stats-grid'>
									<div className='stat-card'>
										<div className='stat-head'>
											<div className='bg-white p-2 rounded-full'>
												<img src={reachIcon} alt='reach' className='stat-icon' />
											</div>
											<div className='stat-title'>Reach</div>
										</div>
										<div className='stat-value'>{analyticsInfo.ad.viewedBy.length}</div>
									</div>
									<div className='stat-card'>
										<div className='stat-head'>
											<div className='bg-white p-2 rounded-full'>
												<img src={clicksIcon} alt='clicks' className='stat-icon' />
											</div>
											<div className='stat-title'>Total Clicks</div>
										</div>
										<div className='stat-value'>{analyticsInfo.ad.clickedBy.length}</div>
									</div>
									<div className='stat-card'>
										<div className='stat-head'>
											<div className='bg-white p-2 rounded-full'>
												<img
													src={impresionIcon}
													alt='impression'
													className='stat-icon'
												/>
											</div>
											<div className='stat-title'>Impression</div>
										</div>
										<div className='stat-value'>
											{/* {analyticsInfo.ad.ad.impression[0].count} */}
											{analyticsInfo.ad.impression[0].count}
										</div>
									</div>
								</div>
								 
			
								<div className='panel'>
									<div className='panel-body'>
										{chartData && <Line data={chartData} options={chartOptions} />}
									</div>
								</div>
			
								<div className='split-grid'>
									<div>
										<table className='table'>
											<tbody>
												<tr>
													<td>Ad Title</td>
													<td>{analyticsInfo.ad.title}</td>
												</tr>
												<tr>
													<td>Description</td>
													<td>{analyticsInfo.ad.description}</td>
												</tr>
												<tr>
													<td>Media Type</td>
													<td>{analyticsInfo.ad.mediaType}</td>
												</tr>
												<tr>
													<td>Ad Type</td>
													<td>{analyticsInfo.ad.adType}</td>
												</tr>
												<tr>
													<td>Status</td>
													<td>
														<span className={`status-badge ${analyticsInfo.ad.status}`}>
															{analyticsInfo.ad.status.charAt(0).toUpperCase() +
																analyticsInfo.ad.status.slice(1)}
														</span>
													</td>
												</tr>
												<tr>
													<td>Subscription Type</td>
													<td>
														<span
															className={`status-badge ${analyticsInfo.ad.subscriptionType}`}
														>
															{analyticsInfo.ad.subscriptionType.charAt(0).toUpperCase() +
																analyticsInfo.ad.subscriptionType.slice(1)}
														</span>
													</td>
												</tr>
												<tr>
													<td>Start Date</td>
													<td>{formatDate(analyticsInfo.ad.startDate)}</td>
												</tr>
												<tr>
													<td>End Date</td>
													<td>{formatDate(analyticsInfo.ad.endDate)}</td>
												</tr>
												<tr>
													<td>Created On</td>
													<td>{formatDate(analyticsInfo.ad.createdAt, true)}</td>
												</tr>
												<tr>
													<td>Last Updated</td>
													<td>{formatDate(analyticsInfo.ad.updatedAt, true)}</td>
												</tr>
												<tr>
													<td>Ad ID</td>
													<td>{analyticsInfo.ad._id}</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div className='media-card'>
										<div style={{ fontWeight: 600, marginBottom: 8 }}>
											Media Preview
										</div>
										{analyticsInfo.ad.mediaType === "image" ? (
											<img src={analyticsInfo.ad.mediaUrl} alt={analyticsInfo.ad.title} />
										) : (
											<a
												href={analyticsInfo.ad.mediaUrl}
												target='_blank'
												rel='noopener noreferrer'
											>
												View Media
											</a>
										)}
									</div>
								</div>
							</div> 
						</InsightsContainer>
		</DashboardLayout>
	);
};

export default AdInsights;
